/* ──────────────────────────────────────────────
   src/hooks/useAsignaturas.ts
   Hook para gestión de asignaturas usando factory CRUD
   ────────────────────────────────────────────── */
import { useCrudResource } from './factories/useCrudResource';
import type { Asignatura } from '../types/entities';

// Re-exportar tipo para compatibilidad
export type { Asignatura };

export function useAsignaturas() {
  return useCrudResource<Asignatura>({
    queryKey: ['asignaturas'],
    endpoint: '/asignaturas',
  });
}
